import { makeContextModule } from '@cian/react-utils';

import { type FC, type PropsWithChildren } from 'react';

import { type ListingAppContext } from '../types/context';

const {
  Context: { Provider: ListingAppContextProvider },
  useContext: useListingAppContext,
} = makeContextModule<ListingAppContext>({
  contextName: 'ListingByPinContext',
});

type TListingAppContextProps = {
  context: ListingAppContext;
};
export const ListingContext: FC<PropsWithChildren<TListingAppContextProps>> = ({ context, children }) => (
  <ListingAppContextProvider value={context}>{children}</ListingAppContextProvider>
);

export { useListingAppContext };
